(() => {
  function initialise() {
    document.querySelectorAll('.tanwa-gear-menu').forEach(details => {
      if (details.dataset.tanwaReady) return;
      details.dataset.tanwaReady = 'true';
      const summary = details.querySelector('summary');
      let timer;
      let hoverOpened = false;
      function close() { details.open = false; summary.setAttribute('aria-expanded', 'false'); hoverOpened = false; }
      summary.addEventListener('click', event => {
        if (hoverOpened) { event.preventDefault(); hoverOpened = false; }
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) document.querySelectorAll('.header__inline-menu details[open]').forEach(other => {
          if (other !== details) { other.open = false; other.querySelector('summary')?.setAttribute('aria-expanded', 'false'); }
        });
      });
      details.addEventListener('pointerenter', event => {
        clearTimeout(timer);
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches && !details.open) { details.open = true; hoverOpened = true; }
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') timer = setTimeout(() => { if (!details.contains(document.activeElement)) close(); }, 180);
      });
      details.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); summary.focus(); } });
      document.addEventListener('click', event => { if (details.open && !details.contains(event.target)) close(); });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
